import React, { useEffect, useState } from 'react';
import { XIcon, ShoppingBagIcon } from 'lucide-react';
const buyers = [{
  name: 'Francesca M.',
  city: 'Bologna'
}, {
  name: 'Giulia R.',
  city: 'Torino'
}, {
  name: 'Marco B.',
  city: 'Milano'
}, {
  name: 'Chiara D.',
  city: 'Firenze'
}, {
  name: 'Alessandro P.',
  city: 'Napoli'
}, {
  name: 'Silvia T.',
  city: 'Verona'
}, {
  name: 'Elena F.',
  city: 'Padova'
}, {
  name: 'Davide C.',
  city: 'Bari'
}, {
  name: 'Martina L.',
  city: 'Roma'
}, {
  name: 'Paolo S.',
  city: 'Genova'
}];
export function SocialProofToast() {
  const [visible, setVisible] = useState(false);
  const [buyer, setBuyer] = useState(buyers[0]);
  useEffect(() => {
    let hideTimer: ReturnType<typeof setTimeout>;
    const show = () => {
      setBuyer(buyers[Math.floor(Math.random() * buyers.length)]);
      setVisible(true);
      hideTimer = setTimeout(() => setVisible(false), 5000);
    };
    const first = setTimeout(show, 3000);
    const interval = setInterval(show, 15000);
    return () => {
      clearTimeout(first);
      clearTimeout(hideTimer);
      clearInterval(interval);
    };
  }, []);
  if (!visible) return null;
  return <div className="fixed bottom-3 left-3 right-3 z-50 animate-toast-in sm:left-auto sm:right-4 sm:w-[280px]" role="status" aria-live="polite" data-id="element-178" data-mp="kcspnvqbw26w">
      <div className="relative overflow-hidden rounded-lg border-2 border-brand-orange bg-white p-2.5 pr-7 shadow-2xl" data-id="element-179" data-mp="ubroynp7elh8">
        <div className="absolute left-0 top-0 h-1 w-full bg-brand-green" data-id="element-180" data-mp="ybsep4hr6j3l" />
        <button type="button" onClick={() => setVisible(false)} aria-label="Chiudi notifica" className="absolute right-1 top-1.5 p-1 text-brand-graphite/40 transition-colors duration-150 ease-out hover:text-brand-graphite" data-id="element-181" data-mp="13ad4e9zdpkds">
          <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-182" data-mp="1i0kqr0sibnjr" />
        </button>
        <div className="flex items-center gap-2.5" data-id="element-183" data-mp="1hyhqzp1jyg1u">
          <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-brand-orange/40 bg-brand-orange/10" data-id="element-184" data-mp="1m2xrfasecv9o">
            <ShoppingBagIcon className="h-4 w-4 text-brand-orange" aria-hidden="true" data-id="element-185" data-mp="3j063z3zcg63p" />
          </div>
          <div className="leading-tight" data-id="element-186" data-mp="3rv3ygfi53qx5">
            <p className="text-[13px] font-extrabold text-brand-navy" data-id="element-187" data-mp="3rw5eyzhxd5m9">
              {buyer.name}
            </p>
            <p className="text-[10px] font-semibold text-brand-graphite/60" data-id="element-188" data-mp="3n2atbqiregkj">
              {buyer.city}, Italia
            </p>
            <p className="text-[11px] font-extrabold text-brand-green" data-id="element-189" data-mp="p2jvwyyuf6r">
              ha acquistato ENGLISH TEACHER PRO™
            </p>
          </div>
        </div>
      </div>
    </div>;
}